// extracted by mini-css-extract-plugin
export default {"icon":"zoomIcon_icon__t4yPX","disabled":"zoomIcon_disabled__cbsnD"};